import React, { useState, useEffect } from 'react';

const NavigationBar = ({ isDarkMode, setIsDarkMode, currentTime }) => {
    const [isScrolled, setIsScrolled] = useState(false);
    const [debounce, setDebounce] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            setIsScrolled(window.scrollY > 10);
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const toggleDarkMode = () => {
        if (debounce) return;
        setDebounce(true);
        setTimeout(() => setDebounce(false), 300);

        setIsDarkMode((prev) => !prev);
    };

    return (
        <nav
            className={`
                fixed w-full
                px-4 md:px-32 lg:px-64 
                py-3 sm:py-4
                flex justify-between items-center 
                z-40
                transition-colors duration-200 ease-in-out
                ${isScrolled
                ? isDarkMode
                    ? 'bg-black/70 backdrop-blur-md backdrop-saturate-150'
                    : 'bg-white/70 backdrop-blur-md backdrop-saturate-150'
                : 'bg-transparent'
            }
            `}
        >
            {/* Left side */}
            <div className="flex flex-col sm:flex-row items-start sm:items-center text-xs sm:text-sm opacity-80">
                <a
                    href="/"
                    className="font-mono whitespace-nowrap hover:opacity-100 transition-opacity"
                >
                    pushpalathashenoy.com
                </a>
                <div className="flex flex-wrap sm:ml-4 mt-1 sm:mt-0">
                    <span className="font-mono whitespace-nowrap hidden md:inline text-xs sm:text-sm">
                        Pune, Maharashtra
                    </span>
                    {/* Show time only on desktop */}
                    <span className="font-mono whitespace-nowrap hidden lg:inline lg:ml-4 text-xs sm:text-sm">
                        {currentTime}
                    </span>
                </div>
            </div>

            {/* Right side */}
            <button
                onClick={toggleDarkMode}
                className="p-1.5 opacity-90 hover:opacity-100
                          transition-transform duration-150 ease-in-out
                          active:scale-95 touch-manipulation relative group
                          sm:scale-105"
                aria-label="Toggle dark mode"
            >
                <div className={`absolute inset-0 rounded-full blur-lg transform scale-125
                              transition-all duration-200 ${
                    isDarkMode
                        ? 'bg-blue-400/20'
                        : 'bg-gray-300/30'
                }`}
                />
                <svg
                    viewBox="0 0 24 24"
                    width="20"
                    height="20"
                    className="relative transition-transform duration-200 hover:scale-110
                             sm:w-5 sm:h-5 lg:w-6 lg:h-6"
                >
                    <path
                        d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"
                        stroke={isDarkMode ? "white" : "#6B7280"}
                        strokeWidth="1.5"
                        fill={isDarkMode ? "white" : "#9CA3AF"}
                        fillOpacity="0.9"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            </button>
        </nav>
    );
};

export default NavigationBar;